import React from "react"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"
import Changes from "@/components/activities/changes"

interface CreatedProps {
  activity: any
  className?: string
}

const Created = ({ activity, className }: CreatedProps) => {
  const LABELS = {
    email: i18n.t("app.activities.account.field_labels.email"),
    businessName: i18n.t("app.activities.account.field_labels.business_name"),
    country: i18n.t("app.activities.account.field_labels.country"),
  }

  const formatters = {}

  return (
    <ActivityBase
      data-testid="panel-activity-account-created"
      activityKey={activity.key}
      text={
        <>
          {i18n.react("app.activities.account.created.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          <Changes changes={activity.parameters} labels={LABELS} formatters={formatters} />
        </>
      }
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default Created
